module.exports = __webpack_public_path__ + "img/ch10_05_汉服衣橱课.ccaa6163.jpg";